export default __webpack_public_path__ + "static/illustration-action-three.url-695eb36f8f639e86fbe2598aba2ec8b0.svg";